import { render } from "./SubstituteModal.vue?vue&type=template&id=7ddb9e20&scoped=true"
import script from "./SubstituteModal.vue?vue&type=script&lang=js"
export * from "./SubstituteModal.vue?vue&type=script&lang=js"

import "./SubstituteModal.vue?vue&type=style&index=0&id=7ddb9e20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddb9e20"]])

export default __exports__